import './color-theme.css';
import './image-fit.css';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import WhyUs from './components/WhyUs';
import Bridal from './components/Bridal';
import Transformations from './components/Transformations';
import Reviews from './components/Reviews';
import Team from './components/Team';
import Appointment from './components/Appointment';
import ContactFooter from './components/ContactFooter';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import { createWhatsAppUrl } from './utils/whatsapp';

function App() {
  const handleLinkClick = (event) => {
    const link = event.target.closest('a');
    if (!link) return;

    const isHeaderSectionLink =
      link.closest('.main-nav') && link.hash && !link.classList.contains('nav-book');
    if (isHeaderSectionLink) return;

    event.preventDefault();
    const label =
      link.getAttribute('aria-label') ||
      link.textContent.trim().replace(/\s+/g, ' ') ||
      'the salon website';

    window.open(
      createWhatsAppUrl(`Hi! I need help with: ${label}`),
      '_blank',
      'noopener,noreferrer'
    );
  };

  return (
    <div className="app-shell" onClickCapture={handleLinkClick}>
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <WhyUs />
        <Bridal />
        <Transformations />
        <Reviews />
        <Team />
        <Appointment />
        <ContactFooter />
      </main>
      <FloatingWhatsApp />
    </div>
  );
}

export default App;
